import { DashboardLayoutCustomer } from "../../components/dashboard-layout-customer";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";

import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper, Chip, Pagination, TextField, InputAdornment, IconButton, CircularProgress, Grid, Card, CardContent } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import { t } from "i18next";
import { useLocation, useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';

function SetXD() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [second, setSecond] = useState(0);
    const [minute, setMinute] = useState(0);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState(null);

    const [listPlayerHistory, setListPlayerHistory] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);

    function formatDateTimeFull(dateStr) {
        if (!dateStr) return "";
        const m = new Date(dateStr);
        if (isNaN(m.getTime())) return "";
        return (
            ("0" + m.getDate()).slice(-2) + "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) + "/" +
            m.getFullYear() + " " +
            ("0" + m.getHours()).slice(-2) + ":" +
            ("0" + m.getMinutes()).slice(-2) + ":" +
            ("0" + m.getSeconds()).slice(-2)
        );
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const getBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = { 
            "6": "LẺ", "5": "CHẴN", 
            "4": "3 TRẮNG 1 ĐỎ", "3": "3 ĐỎ 1 TRẮNG", 
            "2": "4 TRẮNG", "1": "4 ĐỎ",
            "0011": "CHẴN", "0111": "LẺ",
            "0001": "3 TRẮNG 1 ĐỎ", "1110": "3 ĐỎ 1 TRẮNG",
            "0000": "4 TRẮNG", "1111": "4 ĐỎ"
        };
        return stateStr.split(" ").map(s => map[s] || s).join(", ");
    };

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xd45s/list30bet?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setList30(res.data.data);
        }).catch(() => setList30(null));

        axios.get(`${process.env.REACT_APP_API_URL}/xd45s/getadmin?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                    setBet(res.data.data[0]);
                } else if (res.data.data._id) {
                    setBet(res.data.data);
                }
            }
        });
    };

    const fetchCurrentBets = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xd45s/getcurrent?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setCurrent(res.data.data);
        }).catch(() => setCurrent([]));
    };

    const fetchPlayerHistory = useCallback((pageNum, keyword, isSilent = false) => {
        if (!isSilent) setIsLoadingHistory(true); 
        const query = keyword ? `&username=${keyword}` : "";
        axios.get(`${process.env.REACT_APP_API_URL}/XD45s/history-all-players?sanh=${SANH_ID}&page=${pageNum}&limit=10${query}`)
            .then((res) => {
                if (res.data.success) {
                    setListPlayerHistory(res.data.data);
                    setTotalPages(res.data.totalPages || 1);
                    setPage(pageNum);
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                if (!isSilent) setIsLoadingHistory(false);
            });
    }, [SANH_ID]);

    useEffect(() => {
        const silentUpdateTimer = setInterval(() => {
            fetchPlayerHistory(page, searchKeyword, true); 
        }, 3000);
        return () => clearInterval(silentUpdateTimer);
    }, [page, searchKeyword, fetchPlayerHistory]);

    const handleSearch = () => { setPage(1); fetchPlayerHistory(1, searchKeyword, false); };

    const fetchNewSessionAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xd45s/getadmin?sanh=${SANH_ID}`).then((res) => {
            let currentBet = null;
            if (res.data && res.data.data) {
                if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                    currentBet = res.data.data[0];
                } else if (res.data.data._id) {
                    currentBet = res.data.data;
                }
            }
            if (currentBet) {
                setBet(currentBet);
                setDulieunhap(new Date(currentBet.createdAt));
            }
        }).catch(() => console.log("Chờ phiên mới..."));

        reloadHistorySilently();
        fetchCurrentBets(); 
        fetchPlayerHistory(1, "", false); 
    };

    useEffect(() => {
        setBet(null);
        setCurrent(null);
        setList30(null);
        fetchNewSessionAdmin();
    }, [SANH_ID]);

    useEffect(() => {
        if (!dulieunhap) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diffInSeconds = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            let remaining = 45 - diffInSeconds;
            if (remaining > 45) remaining = 45;
            if (remaining <= 0) {
                setSecond(0);
                setMinute(0);
                fetchNewSessionAdmin();
            } else {
                setMinute(Math.floor(remaining / 60));
                setSecond(remaining % 60);
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap, SANH_ID]);

    useEffect(() => {
        const pollInterval = setInterval(() => {
            fetchCurrentBets();
        }, 1500);
        return () => clearInterval(pollInterval);
    }, [SANH_ID]);

    function thongke(num) {
        if (current && current.length > 0) {
            let totalMoney = 0;
            current.forEach((item) => {
                const states = item.state.split(" ").map(Number);
                if (states.includes(num)) {
                    totalMoney += item.money / states.length;
                }
            });
            return Number(totalMoney).toLocaleString("vi-VN");
        }
        return 0;
    }

    const currentSessionData = list30?.find(item => item.id_bet === bet?.id_bet);
    const displayResult = currentSessionData?.result || bet?.result;

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayoutCustomer>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    <Container maxWidth={false}>
                        {/* CHỌN SẢNH */}
                        <Box sx={{ display: 'flex', gap: 1, mb: 3, flexWrap: 'wrap' }}>
                            {[1, 2, 3, 4, 5, 6].map((sanhId) => (
                                <Button
                                    key={sanhId}
                                    variant={SANH_ID === sanhId ? "contained" : "outlined"}
                                    onClick={() => navigate(`?sanh=${sanhId}`)}
                                    sx={{ fontWeight: 'bold', minWidth: '100px' }}
                                >
                                    SẢNH {sanhId}
                                </Button>
                            ))}
                        </Box>

                        <div className="container_set" style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>
                            THEO DÕI XÓC ĐĨA 45S - SẢNH {SANH_ID}
                        </div>

                        {/* ĐỒNG HỒ PHIÊN */}
                        <Paper elevation={2} sx={{ p: 2, textAlign: 'center', mb: 3, bgcolor: '#fafafa' }}>
                            {bet ? (
                                <Typography variant="h6">Phiên hiện tại: <b style={{color: '#1976d2'}}>#{bet.id_bet}</b></Typography>
                            ) : (
                                <Typography>{t("waiting")}</Typography>
                            )}
                            <Typography sx={{ color: "red", fontSize: '35px', fontWeight: 'bold', fontFamily: 'monospace' }}>
                                0{minute} : {second < 10 ? "0" : ""}{second >= 0 ? second : 0}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Kết quả dự kiến: <b style={{color: 'red'}}>{displayResult || "Chưa có"}</b>
                            </Typography>
                        </Paper>

                        {/* THỐNG KÊ CƯỢC NHANH */}
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            {[
                                { label: "LẺ", val: 6, color: '#d32f2f' },
                                { label: "CHẴN", val: 5, color: '#1976d2' },
                                { label: "3 TRẮNG", val: 4, color: '#d32f2f' },
                                { label: "3 ĐỎ", val: 3, color: '#1976d2' },
                                { label: "4 TRẮNG", val: 2, color: '#d32f2f' },
                                { label: "4 ĐỎ", val: 1, color: '#1976d2' }
                            ].map((item, idx) => (
                                <Grid item xs={4} md={2} key={idx}>
                                    <Card variant="outlined" sx={{ textAlign: 'center' }}>
                                        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>{item.label}</Typography>
                                        <Typography sx={{ color: item.color, fontWeight: 'bold' }}>{thongke(item.val)}</Typography>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>

                        <Typography variant="h6" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                        
                        </Typography>
                        <Paper sx={{ mb: 4, overflow: 'hidden' }}>
                            <Table size="small">
                                <TableHead><TableRow sx={{ bgcolor: '#eceff1' }}>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Tài Khoản</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Cửa Đặt</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Tiền Cược</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Thời Gian</TableCell>
                                </TableRow></TableHead>
                                <TableBody>
                                    {current?.length > 0 ? current.map((item, idx) => (
                                        <TableRow key={idx} hover>
                                            <TableCell sx={{ fontWeight: 'bold', color: '#1976d2' }}>{item?.user?.username}</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', color: '#e53935' }}>{getBetLabel(item.state)}</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', color: '#2e7d32' }}>{Number(item.money).toLocaleString("vi-VN")}</TableCell>
                                            <TableCell sx={{ fontSize: '12px' }}>{formatDateTimeFull(item.createdAt)}</TableCell>
                                        </TableRow>
                                    )) : <TableRow><TableCell colSpan={4} align="center" sx={{ py: 3, color: '#999' }}>Không có ai đang cược</TableCell></TableRow>}
                                </TableBody>
                            </Table>
                        </Paper>

                   

                    </Container>
                </Box>
            </DashboardLayoutCustomer>
        </ThemeProvider>
    );
}

export default SetXD;